var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({staticClass:"stock-indicator",style:({ backgroundColor: _vm.indicatorColor })},'div',attrs,false),on))]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('entities.items.stockInfo', { stock: _vm.available }))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }